const styleId = "sur-acsb-print-hide";

// accessiBe renders its trigger inside a shadow root whose adopted stylesheet resets every property
// with `!important`. Shadow-tree important declarations outrank document ones, so no page-level CSS
// can hide it - the print rule has to live inside each shadow root.
const printCss = `@media print {
    .trigger-button,
    .skip-link,
    .popup-dialog {
        display: none !important;
    }
}`;

const injectIntoShadowRoots = () => {
    document.querySelectorAll("access-widget-ui").forEach(host => {
        const shadowRoot = host.shadowRoot;
        if (!shadowRoot || shadowRoot.getElementById(styleId)) {
            return;
        }
        const style = document.createElement("style");
        style.id = styleId;
        style.textContent = printCss;
        shadowRoot.appendChild(style);
    });
};

export default function hideAccessibilityWidgetOnPrint() {
    if (typeof window === "undefined" || (window as any).surAcsbPrintHideInstalled) {
        return;
    }
    (window as any).surAcsbPrintHideInstalled = true;

    const start = () => {
        injectIntoShadowRoots();

        // The widget script bootstraps asynchronously and can recreate its hosts, so keep watching.
        new MutationObserver(injectIntoShadowRoots).observe(document.body, { childList: true });

        // A host can be inserted before its shadow root is attached, which the observer would miss.
        let attempts = 0;
        const intervalId = window.setInterval(() => {
            injectIntoShadowRoots();
            attempts += 1;
            if (attempts >= 20) {
                window.clearInterval(intervalId);
            }
        }, 500);
    };

    if (document.body) {
        start();
    } else {
        window.addEventListener("DOMContentLoaded", start, { once: true });
    }
}
